import { type JavascriptRequestDataModelSuccess, ZowieSettings } from 'autogen/swagger/all';
import { JavascriptRequestDataModelQueryKey } from 'autogen/swagger/all/hooks';
import WebsiteSettings from 'modules/websiteSettings';
import queryClient from 'setup/react-query/queryClient';

export type ZowieInitOptions = {
    onLoaded?: () => void;
    onShow?: () => void;
    onClose?: () => void;
};

export default function initZowie(options?: ZowieInitOptions) {
    const { featureToggles } = queryClient.getQueryData([
        JavascriptRequestDataModelQueryKey
    ]) as JavascriptRequestDataModelSuccess;

    ((d, id, cb) => {
        const js = d.createElement('script');
        const n = d.createElement('div');
        const wrapper = d.createElement('div');
        const style = d.createElement('style');
        style.innerHTML = `
            #chatbotize > div {
                transition: none !important;
            }
            #zowieChatbotWrapper {
                height: 100% !important;
                width: 100% !important;
                bottom: 0 !important;
                right: 0 !important;
                border-radius: 0 !important;
                transition: transform 500ms ease-in-out !important;
                transform: translateX(101%);
            }
            @media (min-width: 768px) {
                #zowieChatbotWrapper {
                    max-width: 480px !important;
                }
            }
            #zowieChatbotWrapper.openanimation {
                transform: translateX(0%);
            }
            #zowieFloatingButton {
                display: none !important;
            }`;

        wrapper.id = 'chatbotize-wrapper';
        n.id = id;
        if (featureToggles.isCOMAIEnabled) {
            wrapper.appendChild(style);
        }
        wrapper.appendChild(n);
        // @ts-ignore
        if (js.readyState) {
            // @ts-ignore
            js.onreadystatechange = () => {
                // @ts-ignore
                if (js.readyState === 'loaded' || js.readyState === 'complete') {
                    // @ts-ignore
                    js.onreadystatechange = null;
                    cb();
                }
            };
        } else {
            js.onload = () => {
                cb();
            };
        }
        js.src = 'https://matas.chat.getzowie.com/web/live-chat/chatbotize-entrypoint.min.js';
        document.body.appendChild(js);
        document.body.appendChild(wrapper);
    })(document, 'chatbotize', () => {
        window.Zowie.init({
            instanceId: WebsiteSettings.liveChat.zowieInstanceId,
            allowDownloadTranscript: false,
            sessionTimeout: 3600000,
            zendeskAccountKey: WebsiteSettings.liveChat.zowieZendeskAccountKey,
            content: {
                endChatQuestion: window.Translations.Website.Chat.EndChatQuestion,
                endChatButtonYesCaption: window.Translations.Website.Chat.EndChatButtonYesCaption,
                endChatButtonNoCaption: window.Translations.Website.Chat.EndChatButtonNoCaption,
                endChatButtonCaption: window.Translations.Website.Chat.EndChatButtonCaption
            },
            startOnOpen: true,
            headerMode: 'white',
            onShow: () => {
                document.getElementById('zowieChatbotWrapper')?.classList.add('openanimation');
                options?.onShow?.();
            },
            onclose: () => {
                options?.onClose?.();
            },
            onLoaded: () => {
                window.Zowie.setAccessTokenCallback(async (onSuccess, onError) => {
                    try {
                        const token = await ZowieSettings();
                        if (token.userToken) {
                            const data = JSON.parse(token.userToken);
                            onSuccess(data.access_token);
                        } else {
                            onSuccess(null);
                        }
                    } catch (error) {
                        onError(error);
                    }
                });
                options?.onLoaded?.();
                if (WebsiteSettings.liveChat.openZowieOnLoad) {
                    window.Zowie.open();
                }
            }
        });
    });
}
